import React from "react";
import { useLocation } from "react-router-dom";
import { makeStyles } from "@mui/styles";

import ScrollToTop from "./ScrollToTop";
import Footer from "./Footer";
import Header from "./Header";
import ScrollToTopButton from "./ScrollToTopButton";

const useStyles = makeStyles({
    root: {
      display: "flex",
      flexDirection: "column",
      minHeight: "100vh",
      background: "var(--gray-50)",
    },
    content: {
      flex: "1",
      position: "relative",
      overflow: "hidden",
    },
});

const RouteWithDefaultLayout = ({ component: Component }) => {
    const classes = useStyles();
    const location = useLocation();

    return (
        <>
            <ScrollToTop>
                <div className={classes.root}>
                    <Header location={location} />
                    <div className={classes.content}>
                        <Component />
                        <ScrollToTopButton />
                    </div>
                    <Footer />
                </div>
            </ScrollToTop>
        </>
    );
};

RouteWithDefaultLayout.displayName = "RouteWithDefaultLayout";

export default RouteWithDefaultLayout;
